<template>
  <div class="documents-grid" data-cy="documents-grid">
    <div v-for="(card, index) in documentData" :key="index">
      <Card class="document-card">
        <div class="document-card-header">
          <a class="form-link" @click="download(card)">
            <ExcelIcon v-if="card.Excel" class="doc-file-icon" />
            <WordIcon v-else class="doc-file-icon" />
          </a>
        </div>

        <div class="footer">
          {{ card.DocumentName }}
        </div>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Card } from "@progress/kendo-vue-layout";
import ExcelIcon from "@/icons/ExcelIcon.vue";
import WordIcon from "@/icons/WordIcon.vue";
import { api } from "@/api";

interface DocumentData {
  DocumentName: string;
  FileName: string;
  Excel: boolean;
}

const documentData = [
  {
    DocumentName: "New Plant",
    FileName: "PlantApplication",
    Excel: true,
  },
  {
    DocumentName: "New Ingredient",
    FileName: "IngredientApplication",
    Excel: true,
  },
  {
    DocumentName: "New Product/Private Label",
    FileName: "ProductsApplication",
    Excel: true,
  },
  {
    DocumentName: "Terminate Product",
    FileName: "NewProductTermination",
    Excel: false,
  },
  {
    DocumentName: "Terminate Private Label",
    FileName: "PrivateLabelTermination",
    Excel: false,
  },
  {
    DocumentName: "Terminate Company/Plant",
    FileName: "CompanyPlantTermination",
    Excel: false,
  },
] as DocumentData[];

const download = function (documentData: DocumentData) {
  api.getDownload("GetDocFile", {
    fileName: documentData.FileName,
  });
};
</script>

<style scoped lang="scss">
.k-card-header {
  width: 200px;
  padding: 0px;
}

.document-card {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.1);

  &-header {
    background: transparent;
    cursor: pointer;
  }
}

.doc-file-icon {
  height: 200px;
  width: 200px;
}

.documents-grid {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 16px;
}

.footer {
  display: flex;
  justify-content: center;
  background: #f6f6f6;
  font-family: "museo-sans", helvetica, arial, sans-serif;
  font-size: 13px;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>
